import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
// const ignoreApiErrors = [401, 422, 500];

if (process.env.REACT_APP_SENTRY_KEY) {
  Sentry.init({
    release: process.env.REACT_APP_VERSION || "default-release",
    environment: process.env.REACT_APP_CUSTOM_ENV,
    dsn: process.env.REACT_APP_SENTRY_KEY,
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
      // Sentry.replayIntegration({
      //   beforeAddRecordingEvent: event => {
      //     if (
      //       event.data.tag === "performanceSpan" &&
      //       (event.data.payload.op === "resource.fetch" || event.data.payload.op === "resource.xhr") &&
      //       ignoreApiErrors.includes(event.data.payload.data.statusCode)
      //     ) {
      //       return null;
      //     }
      //     return event;
      //   }
      // })
    ],
    beforeSend(event) {
      if (event.exception && event.exception.values) {
        for (const exception of event.exception.values) {
          if (exception.value && exception.value.includes(`Request failed with status code`)) {
            return null;
          }
        }
      }
      return event;
    },
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_SAMPLE_RATE || 1)

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // replaysSessionSampleRate: Number(process.env.REACT_APP_SENTRY_SAMPLE_RATE || 1),
    // replaysOnErrorSampleRate: 0.2
  });
  Sentry.setTag("domain", `${window.location.origin}`);
}
